import { ScrollTrigger } from 'gsap/all'

// FloatingButton — l-main の下端が画面下端に達したら非表示（ScrollTrigger）
export default class FloatingButton {
  constructor() {
    this.button = document.querySelector('.js-floating-button')
    this.main = document.querySelector('.l-main')
    this.trigger = null
    this.init()
  }

  init() {
    if (!this.button || !this.main) {
      return
    }

    this.trigger = ScrollTrigger.create({
      trigger: this.main,
      start: 'bottom bottom',
      onEnter: () => this.button.classList.add('is-hidden'),
      onLeaveBack: () => this.button.classList.remove('is-hidden'),
      invalidateOnRefresh: true,
    })
  }

  destroy() {
    this.trigger?.kill()
    this.trigger = null
    this.button?.classList.remove('is-hidden')
  }
}
